import { createMuiTheme } from "@material-ui/core/styles";

export const blueTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#284764"
    },
    secondary: {
      main: "#258AAD"
    }
  }
});
